import React from "react";
import { ModalTemplate } from "../../templates/ModalTemplate";
import { DetailOwnerForm } from "../form/DetailOwnerForm";
import { Owner } from "../../../ducks/owner/types";

type Props = {
    isOpen: boolean;
    onClose: () => void;
    owner: Owner;
};

export const DetailOwnerModal: React.FC<Props> = ({ isOpen, onClose, owner }) => {
    return (
        <ModalTemplate
            isOpen={isOpen}
            title="Owner Details"
            onClose={onClose}
            maxWidth="800px"
        >
            <DetailOwnerForm owner={owner} />
        </ModalTemplate>
    );
}; 